// src/components/ResumenCotizacion.jsx
import React from "react";
import ResumenCotizacionV1 from "./ResumenCotizacionV1";
import ResumenCotizacionV2 from "./ResumenCotizacionV2";

/**
 * Usa V1 si la cotización no tiene 'resumenVersion' (compatibilidad hacia atrás)
 * o si explícitamente es 1. Usa V2 cuando 'resumenVersion' sea 2 (o mayor).
 */
export default function ResumenCotizacion(props) {
  const version = props.cotizacion?.resumenVersion ?? 1;
  if (version >= 2) {
    return <ResumenCotizacionV2 {...props} />;
  }
  return <ResumenCotizacionV1 {...props} />;
}
